import { createRouter, createWebHashHistory } from 'vue-router'

import { ref, watch } from "vue";

// PC端路由
const routesPc =  [
  {
    path: '/SpringFestival',
    name: 'pcdmcstore',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('@/views/mdmcstore.vue'),
    meta: {
        title: '《航海王：燃烧意志》恭贺新禧 狂欢开启',
        showTab: false,
      },
  },

  
]


// 移动端路由表
const routesMB = [
  {
    path: '/SpringFestival',
    name: 'pcdmcstore',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('@/views/mdmcstore.vue'),
    meta: {
        title: '《航海王：燃烧意志》恭贺新禧 狂欢开启',
        showTab: false,
      },
  },

 
]

// const router = createRouter({
//   history: createWebHashHistory(),
//   routes
// })

// 声明变量用来接routers
var routes = [];
const screenWidth = ref()
// 获取页面宽度
screenWidth.value = document.body.clientWidth
if (screenWidth.value <= 1200) {
    routes = routesMB
} else {
    routes = routesPc
}
window.onresize = () => {
    screenWidth.value = document.body.clientWidth;
};
// 监听页面宽度
watch(screenWidth, (newVal, oldVal) => {
    let timer = setTimeout(() => {
        if (newVal <= 1200) {
            // 小于758就是移动端 就把移动端路由表赋给routes
            console.log('is Mobile');
            routes = routesMB
            window.location.reload()
        } else {
            // 大于就是pc端，把pc端路由表赋给routes
            routes = routesPc
            window.location.reload()
        }
        // 重绘页面
    }, 500)
    return () => {
        // 清除定时器
        clearTimeout(timer)
    }
}, {
    // 深度清除
    deep: true,
})
 
 
 
const router = createRouter({
    history: createWebHashHistory(),
    routes,
   
})


router.beforeEach((to, from, next) => {
    document.title = (to?.meta?.title) || document.title;
    next();
  })
  

export default router
